import React, { useEffect, useState, useRef } from 'react'
import NavbarMob from '../components/NavbarMob'
import Navbar from '../components/Navbar'
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import top from '../images/FullImage/top.png'
import down from '../images/FullImage/down.png'
import cart1 from '../images/FullImage/cart.png'
import payment from '../images/FullImage/payment.png'
import line from '../images/Home/line.png'
import product1 from '../images/Home/product2.webp'
import heart from '../images/Home/heart.png'
import filledHeart from '../images/Home/heart2.png';
import FooterMob from '../components/FooterMob'
import Footer from '../components/Footer'
import fit from '../images/FullImage/Fit.png'

import strechable from '../images/FullImage/stretchable.png'
import drops from '../images/FullImage/drops.png'
import winter from '../images/FullImage/winter.png'
import wind_sign from '../images/FullImage/wind-sign.png'


import shipping from '../images/FullImage/shipping.png'
import returns from '../images/FullImage/Returns.png'
import Modal from './modalImage'
import axios from 'axios'
import { useStore } from '../useStore'
import LiveViews from './LiveViews'
import animationData from "../lotties/Live.json";
import Lottie from "lottie-react";
import SimilarProductItem from './SimilarProductItem';

function FullImage() {
    const [similarProducts, setSimilarProducts] = useState([]);
    const [product, setProduct] = useState([]);
    const [selectedItemName, setSelectedItemName] = useState('');
    const [productDetails, setProductDetails] = useState([]);
    const [selectedSize, setSelectedSize] = useState("");
    const [selectedColor, setSelectedColor] = useState("");
    const [loginId, setLoginId] = useState(null);
    const [offerPrices, setOfferPrices] = useState({});
    const [wishlistItems, setWishlistItems] = useState([]);
    const [extraImages, setExtraImages] = useState({}); // Store extra images by color code
    const [loadingExtraImages, setLoadingExtraImages] = useState({}); // Track loading state for extra images
    const [fabricData, setFabricData] = useState(null);
    const [loadingFabric, setLoadingFabric] = useState(false);
    const [mainImage, setMainImage] = useState(null);
    const [currentColorCode, setCurrentColorCode] = useState('');

    const admin = useSelector((state) => state.user.admin);
    const { showDropdown, setShowDropdown } = useStore();

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });

    const location = useLocation();
    const navigate = useNavigate();

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const userId = useSelector((state) => state.user.id);

    const LedName = localStorage.getItem('loginName');
    const LedEmail = localStorage.getItem('loginEmail');

    const imageCacheRef = useRef(new Map());
    const productAbortControllerRef = useRef(null);
    const similarAbortControllerRef = useRef(null);
    const mountedRef = useRef(true);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
            if (productAbortControllerRef.current) productAbortControllerRef.current.abort();
            if (similarAbortControllerRef.current) similarAbortControllerRef.current.abort();
        };
    }, []);

    // Get ID and itemName from URL
    const [id, setId] = useState('');
    const [itemName, setItemName] = useState('');

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const encodedId = queryParams.get("I");
        const encodedName = queryParams.get("N");

        if (encodedId) {
            const decodedId = atob(encodedId);
            setId(decodedId);
        }

        if (encodedName) {
            const decodedName = atob(encodedName);
            setItemName(decodedName);
        }
    }, [location.search]);

    const cutitemId = itemName ? itemName.split(' ')[0] : '';

    useEffect(() => {
        const storedLoginId = localStorage.getItem('loginId');
        setLoginId(storedLoginId);
    }, []);

    const [modifiedColors, setModifiedColors] = useState([]);
    const [images, setImages] = useState([]);
    const [productItems, setProductItems] = useState([]);

    useEffect(() => {
        const fetchModifiedColors = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const data = await response.json();
                const modifiedColors = data.reduce((acc, item) => {
                    acc[item.db_color] = {
                        name: item.md_color?.toUpperCase() || '',
                        hex: item.hex || ''
                    };
                    return acc;
                }, {});
                setModifiedColors(modifiedColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };
        fetchModifiedColors();
    }, []);

    // Function to fetch extra images for a color code
    const fetchExtraImages = async (colorCode) => {
        if (!colorCode) return;

        setLoadingExtraImages(prev => ({ ...prev, [colorCode]: true }));

        try {
            // Fetch all extra images from server
            const response = await axios.get(`${apiLocalUrl}/getExtraImages`);
            const allExtraImages = response.data || [];

            // Filter images for this color code
            const colorExtraImages = allExtraImages
                .filter(name => {
                    // Remove .webp extension and check if it starts with the color code
                    const imageKey = name.replace('.webp', '');
                    // Check if it matches pattern: colorCode_1, colorCode_2, etc.
                    return imageKey.startsWith(colorCode) &&
                        imageKey !== colorCode && // Exclude main image (we'll add it separately)
                        /\d+$/.test(imageKey.replace(colorCode + '_', '')); // Has number at end
                })
                .map(name => {
                    return {
                        url: `${apiLocalUrl}/uploads/subImages/${name}`,
                        name: name.replace('.webp', ''),
                        isMain: false // Mark as extra image
                    };
                })
                .sort((a, b) => {
                    // Sort by number suffix
                    const numA = parseInt(a.name.replace(colorCode + '_', ''));
                    const numB = parseInt(b.name.replace(colorCode + '_', ''));
                    return numA - numB;
                });

            // Add the main image as the first item
            const mainImageUrl = `${apiLocalUrl}/uploads/${colorCode}.webp`;
            const allImagesForColor = [
                {
                    url: mainImageUrl,
                    name: colorCode,
                    isMain: true
                },
                ...colorExtraImages
            ];

            setExtraImages(prev => ({
                ...prev,
                [colorCode]: allImagesForColor
            }));
        } catch (err) {
            console.error('Error fetching extra images:', err);
            // Even if extra images fail, still add the main image
            const mainImageUrl = `${apiLocalUrl}/uploads/${colorCode}.webp`;
            setExtraImages(prev => ({
                ...prev,
                [colorCode]: [{
                    url: mainImageUrl,
                    name: colorCode,
                    isMain: true
                }]
            }));
        } finally {
            setLoadingExtraImages(prev => ({ ...prev, [colorCode]: false }));
        }
    };

    // Fetch fabric data whenever the ID changes
    useEffect(() => {
        const fetchFabric = async () => {
            if (!id) return;
            setLoadingFabric(true);
            try {
                const response = await axios.get(`${apiLocalUrl}/get-fabric-data/${id}/BLACKBATON_2526`);
                if (response.data.success) {
                    setFabricData(response.data.data);
                } else {
                    setFabricData(null);
                }
            } catch (error) {
                console.error("Error fetching fabric details:", error);
                setFabricData(null);
            } finally {
                setLoadingFabric(false);
            }
        };
        fetchFabric();
    }, [id, apiLocalUrl]);

    // Enhanced getUniqueColors function
    const getUniqueColors = (colors) => {
        const seen = new Set();
        return colors.filter(color => {
            if (!color) return false;
            const normalizedColor = color.toString().toUpperCase();
            if (!normalizedColor || seen.has(normalizedColor)) return false;
            const hasImage = images.some(
                img => img.Color && img.Color.toString().toUpperCase() === normalizedColor
            );
            if (!hasImage) return false;
            seen.add(normalizedColor);
            return true;
        });
    };

    // Function to get available colors for a specific size
    const getColorsForSize = (size) => {
        return productDetails
            .filter((detail) => detail.Size === size)
            .map((detail) => detail.Color);
    };

    // Function to check if a size has any colors
    const sizeHasColors = (size) => {
        const colors = getColorsForSize(size);
        return getUniqueColors(colors).length > 0;
    };

    // Function to check if an image exists
    // const checkImageExists = async (imageUrl) => {
    //     try {
    //         const res = await fetch(`${apiLocalUrl}/check-image/${imageUrl}`);
    //         const data = await res.json();
    //         return data.exists;
    //     } catch {
    //         return false;
    //     }
    // };

    const checkImageExists = async (image) => {
        try {
            const res = await fetch(`${apiLocalUrl}/check-image/${encodeURIComponent(image)}`);

            if (!res.ok) {
                return false;
            }

            const data = await res.json();
            return data.exists;
        } catch (err) {
            return false;
        }
    };

    const [showZoom, setShowZoom] = useState(false);
    const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
        const yPercent = ((e.clientY - rect.top) / rect.height) * 100;

        setZoomPos({
            x: xPercent,
            y: yPercent,
            mouseX: e.clientX - rect.left,
            mouseY: e.clientY - rect.top
        });
    };


    // Function to get first available color for a product
    const getFirstAvailableColor = async (productId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${productId}`);
            if (response.status === 200) {
                const data = response.data;
                const distinctColors = [...new Set(
                    data.filter(item => item.ItemId === productId).map(item => item.Color?.trim()).filter(Boolean)
                )];

                // Check colors in order
                for (const color of distinctColors) {
                    const imageUrl = `${apiLocalUrl}/uploads/${productId}_${color}.webp`;
                    const exists = await checkImageExists(`${productId}_${color}.webp`);
                    if (exists) {
                        return color;
                    }
                }
                return null;
            }
        } catch (error) {
            console.error('Error fetching product details:', error);
            return null;
        }
    };

    // Function to check if a product has any visible image
    const hasVisibleImage = async (product) => {
        // First check displayFirst
        if (product.displayFirst) {
            const imageCode = product.displayFirst.endsWith('.webp')
                ? product.displayFirst
                : `${product.displayFirst}.webp`;

            const exists = await checkImageExists(imageCode);
            if (exists) return true;
        }

        // If no displayFirst or displayFirst doesn't exist, check for any color image
        const availableColor = await getFirstAvailableColor(product.ID);
        return availableColor !== null;
    };

    // Function to get product image URL
    const getProductImageUrl = async (product) => {
        // First try displayFirst
        if (product.displayFirst) {
            const imageCode = product.displayFirst.endsWith('.webp')
                ? product.displayFirst
                : `${product.displayFirst}.webp`;

            const exists = await checkImageExists(imageCode);
            if (exists) return `${apiLocalUrl}/uploads/${imageCode}`;
        }

        // If displayFirst doesn't exist, get first available color
        const availableColor = await getFirstAvailableColor(product.ID);
        if (availableColor) {
            return `${apiLocalUrl}/uploads/${product.ID}_${availableColor}.webp`;
        }

        // Fallback
        return product1;
    };

    // Fetch product data when ID changes
    useEffect(() => {
        const fetchProductData = async () => {
            if (!id || !modifiedColors || Object.keys(modifiedColors).length === 0) return;

            setLoadingImages('loading');
            setProduct([]);
            setProductDetails([]);
            setProductItems([]);
            setImages([]);
            setSelectedSize("");
            setSelectedColor("");
            setMainImage(null);
            setRespectedSizeArray([]);

            if (productAbortControllerRef.current) productAbortControllerRef.current.abort();
            const controller = new AbortController();
            productAbortControllerRef.current = controller;
            const signal = controller.signal;

            try {
                // Fetch main product
                const productResponse = await fetch(`${apiBaseUrl}/getProductById/BLACKBATON_2526?Id=${id}`);
                const productData = await productResponse.json();

                if (productData.length > 0 && mountedRef.current) {
                    setProduct(productData[0]);
                }

                // Fetch product details
                const detailsResponse = await fetch(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${id}`);
                const detailsData = await detailsResponse.json();

                if (detailsData.length > 0 && mountedRef.current) {
                    setProductItems(detailsData);

                    // Filter valid data
                    const filteredData = detailsData.filter(item => item.Color && item.Color.trim() !== '');
                    setProductDetails(filteredData);

                    // Deduplicate based on mapped color
                    const uniqueColors = detailsData.reduce((acc, item) => {
                        const rawColor = item.Color?.toUpperCase();
                        const mappedColor = modifiedColors[rawColor]?.name;

                        if (!acc.seen.has(mappedColor)) {
                            acc.seen.add(mappedColor);
                            acc.result.push(item);
                        }

                        return acc;
                    }, { seen: new Set(), result: [] }).result;

                    // Check for valid images
                    const validImages = [];

                    for (const item of uniqueColors) {
                        const colorName = modifiedColors[item.Color]?.name;
                        const code = `${item.ItemId}_${colorName}`;
                        const imageUrl = `${apiLocalUrl}/uploads/${code}.webp`;

                        try {

                            const exists = await checkImageExists(`${code}.webp`);
                            if (exists) {
                                validImages.push({ ...item, imageUrl, colorCode: code });
                            }

                            // const response = await fetch(imageUrl, { method: "HEAD" });
                            // if (response.ok) {
                            //     validImages.push({ ...item, imageUrl, colorCode: code });
                            // }
                        } catch { }
                    }

                    if (validImages.length > 0 && mountedRef.current) {
                        setImages(validImages);

                        // Initialize with first available image or displayFirst
                        let initialImage = null;
                        let initialColor = null;
                        let initialSize = null;
                        let initialColorCode = null;

                        // Try displayFirst first
                        if (productData[0]?.displayFirst) {
                            const displayWithoutExt = productData[0].displayFirst.replace('.webp', '');
                            const [itemID, colorName] = displayWithoutExt.split('_');

                            if (colorName) {
                                // Find if this color has a valid image
                                const displayImage = validImages.find(img => {
                                    const imgColorName = modifiedColors[img.Color?.toUpperCase()]?.name;
                                    return imgColorName === colorName;
                                });

                                if (displayImage) {
                                    const displayKey = productData[0].displayFirst.replace('.webp', '');
                                    initialImage = `${apiLocalUrl}/uploads/${displayKey}.webp`;
                                    initialColor = displayImage.Color;
                                    initialColorCode = displayImage.colorCode;
                                    // Find size for this color
                                    initialSize = filteredData.find(detail => detail.Color === displayImage.Color)?.Size;
                                }
                            }
                        }

                        // Function to get available colors for a specific size
                        const getColorsForSize = (size) => {
                            return filteredData
                                .filter((detail) => detail.Size === size)
                                .map((detail) => detail.Color);
                        };

                        // Enhanced getUniqueColors function
                        const getUniqueColors = (colors) => {
                            const seen = new Set();
                            return colors.filter(color => {
                                if (!color) return false;
                                const normalizedColor = color.toString().toUpperCase();
                                if (!normalizedColor || seen.has(normalizedColor)) return false;
                                const hasImage = validImages.some(
                                    img => img.Color && img.Color.toString().toUpperCase() === normalizedColor
                                );
                                if (!hasImage) return false;
                                seen.add(normalizedColor);
                                return true;
                            });
                        };

                        // Function to check if a size has any colors
                        const sizeHasColors = (size) => {
                            const colors = getColorsForSize(size);
                            return getUniqueColors(colors).length > 0;
                        };

                        // If no displayFirst or displayFirst not valid, use first valid image
                        if (!initialImage && validImages[0]) {
                            const firstImage = validImages[0];
                            const colorName = firstImage.Color;
                            initialColor = colorName;
                            initialColorCode = firstImage.colorCode;
                            initialSize = filteredData.find(detail => detail.Color === colorName)?.Size;
                            initialImage = firstImage.imageUrl;
                        }

                        if (initialImage) {
                            setMainImage(initialImage);
                        }
                        if (initialColor) {
                            setSelectedColor(initialColor);
                        }
                        if (initialSize && sizeHasColors(initialSize)) {
                            setSelectedSize(initialSize);
                        }

                        // Set current color code and fetch all images (main + extra)
                        if (initialColorCode) {
                            setCurrentColorCode(productData[0].ID);
                            fetchExtraImages(initialColorCode);
                        }

                        setLoadingImages(false);
                    } else if (mountedRef.current) {
                        setLoadingImages('fail');
                    }
                } else if (mountedRef.current) {
                    setLoadingImages('fail');
                }
            } catch (error) {
                if (error.name === 'AbortError') return;
                console.error('Error fetching product data:', error);
                if (mountedRef.current && !signal.aborted) setLoadingImages('error');
            } finally {
                if (mountedRef.current && !signal.aborted) setLoadingImages(false);
            }
        };

        fetchProductData();
    }, [id, modifiedColors]);

    // Optimized states from SearchPage technique
    const [visibleProducts, setVisibleProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [loadingImages, setLoadingImages] = useState('loading');

    // Fetch similar products when cutitemId changes
    useEffect(() => {
        const fetchSimilarProducts = async () => {
            if (!apiBaseUrl || !cutitemId || !id) return;

            setSimilarProducts([]);
            setVisibleProducts([]);

            if (similarAbortControllerRef.current) similarAbortControllerRef.current.abort();
            const controller = new AbortController();
            similarAbortControllerRef.current = controller;
            const signal = controller.signal;

            try {
                const response = await fetch(
                    `${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?filter=${encodeURIComponent(cutitemId)}`,
                    { signal }
                );
                const allData = await response.json();

                // Handle new API response format
                const productsList = allData.products || (Array.isArray(allData) ? allData : []);

                if (productsList.length > 0) {
                    // Filter out current product
                    const filtered = productsList.filter(a => parseInt(a.ID) !== parseInt(id));

                    // Check each product for visible images
                    const productsWithImages = [];
                    const imagePromises = [];

                    for (const product of filtered) {
                        // If backend already validated (Optimization)
                        if (product.hasValidImage) {
                            productsWithImages.push(product);
                            continue;
                        }

                        imagePromises.push(
                            hasVisibleImage(product).then(hasImage => {
                                if (hasImage) {
                                    productsWithImages.push(product);
                                }
                            })
                        );
                    }

                    // Wait for all image checks to complete
                    await Promise.all(imagePromises);

                    // Show first 8 similar products with images
                    const visibleProductsList = productsWithImages.slice(0, 8);
                    setSimilarProducts(visibleProductsList);

                    // Pre-fetch image URLs for these products
                    const imageMap = {};
                    const imageFetchPromises = visibleProductsList.map(async (product) => {
                        const url = await getProductImageUrl(product);
                        imageMap[product.ID] = url;
                        return url;
                    });
                    await Promise.allSettled(imageFetchPromises);

                    if (mountedRef.current && !signal.aborted) {
                        setSimilarProductImages(prev => ({ ...prev, ...imageMap }));
                    }

                    // Animate them in
                    visibleProductsList.forEach((product, index) => {
                        setTimeout(() => {
                            if (mountedRef.current) {
                                setVisibleProducts(prev => [...prev, product.ID]);
                            }
                        }, index * 150); // Increased delay slightly for better effect
                    });

                    if (visibleProductsList.length > 0 && !selectedItemName && mountedRef.current) {
                        setSelectedItemName(visibleProductsList[0].ItemName);
                    }
                } else {
                    setSimilarProducts([]);
                }
            } catch (error) {
                if (error.name === 'AbortError') return;
                console.error('Error fetching similar products:', error);
            } finally {
                if (mountedRef.current && !signal.aborted) setLoadingProducts(false);
            }
        };

        if (cutitemId && id) {
            fetchSimilarProducts();
        }
    }, [cutitemId, id]);

    // Fetch wishlist items
    useEffect(() => {
        const fetchWishlistItems = async () => {
            try {
                const activeUserId = loginId || userId;
                if (!activeUserId) return;

                const response = await fetch(`${apiBaseUrl}/wishlist/items/BLACKBATON_2526/${activeUserId}`);
                const data = await response.json();

                if (data.success && mountedRef.current) {
                    setWishlistItems(data.items);
                }
            } catch (error) {
                console.error("Error fetching wishlist items:", error);
            }
        };

        if (loginId || userId) {
            fetchWishlistItems();
        }
    }, [loginId, userId]);

    const [startIndex, setStartIndex] = useState(0);
    const imagesPerPage = 3;

    // Handle size selection - also reset pagination
    const handleSizeSelection = async (size) => {
        // Check if size has colors before selecting
        if (!sizeHasColors(size)) {
            console.warn(`Size ${size} has no available colors`);
            return;
        }

        setSelectedSize(size);
        setStartIndex(0); // Reset pagination
        setRespectedSizeArray([]);

        // Find available colors for the selected size
        const colorsForSelectedSize = getColorsForSize(size);
        const uniqueColors = getUniqueColors(colorsForSelectedSize);

        if (uniqueColors.length > 0) {
            // Select first available color
            const firstColor = uniqueColors[0];
            setSelectedColor(firstColor);

            // Find matching product item and update image
            const matchingUniquecode = productItems.find(
                item => item.Color?.toUpperCase() === firstColor && item.Size === size
            );

            if (matchingUniquecode) {
                const colorName = modifiedColors[matchingUniquecode.Color?.toUpperCase()]?.name || firstColor;
                const code = `${matchingUniquecode.ItemId}_${colorName}`;
                // setCurrentColorCode(code);
                const mainImgUrl = `${apiLocalUrl}/uploads/${code}.webp`;
                setMainImage(mainImgUrl);

                // Fetch all images (main + extra) for this color
                fetchExtraImages(code);
            }
        }
    };

    // Handle when an image is clicked from the thumbnail list
    const handleThumbnailClick = (imgUrl) => {
        setMainImage(imgUrl);
        // Reset pagination when a new image is selected
        setStartIndex(0);
    };

    const sizesAllocated = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
    const uniqueSizes = [...new Set(productDetails.map((category) => category.Size))];

    // Get available colors for the selected size
    const availableColors = selectedSize && product.NoSize !== 1
        ? productDetails
            .filter((category) => category.Size === selectedSize)
            .map((category) => category.Color)
        : product.NoSize === 1
            ? productDetails.map((category) => category.Color)
            : [];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    const home = () => {
        navigate('/');
    };

    const fullimage = (newId, newItemName) => {
        // Just navigate - the URL change will trigger the data fetch
        navigate(`/fullimage?I=${btoa(String(newId))}&N=${btoa(newItemName)}`);
    };

    // Optimized wishlist functions
    const addToWishlist = async (productItem) => {
        const apiUrl = `${apiBaseUrl}/wishlist/add/BLACKBATON_2526`;
        const activeUserId = loginId || userId;

        if (!activeUserId) {
            alert("Please login to add items to wishlist");
            return;
        }

        const payload = {
            ID: productItem.ID,
            ItemName: productItem.ItemName,
            MRP: productItem.MRP,
            ledcode: activeUserId,
            Qty: productItem.Qty,
            uniqueCode: productItem.UniqueCode
        };

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setWishlistItems(prev => [...prev, productItem]);
            } else {
                alert("Already in Wishlist");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred");
        }
    };

    const removeFromWishlist = async (productId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/wishlist/delete/BLACKBATON_2526/${productId}`, {
                method: 'DELETE',
            });

            if (response.ok && mountedRef.current) {
                setWishlistItems(prev => prev.filter(item => item.ID !== productId));
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleAddToCart = async (event) => {
        event.stopPropagation();

        if (!loginId) {
            alert('Please login to continue.');
            navigate('/login');
            return;
        }

        let selectedProductDetail;

        if (product.NoSize !== 1) {
            if (!selectedSize || !selectedColor) {
                alert('Please select a size and color.');
                return;
            }

            selectedProductDetail = productDetails.find(
                (detail) =>
                    detail.Size === selectedSize &&
                    detail.Color === selectedColor
            );

            if (!selectedProductDetail) {
                alert('Please select a valid size and color.');
                return;
            }
        } else {
            if (!selectedColor) {
                alert('Please select a color.');
                return;
            }

            selectedProductDetail = productDetails.find(
                (detail) => detail.Color === selectedColor
            );

            if (!selectedProductDetail) {
                alert('Please select a valid color.');
                return;
            }
        }

        const uniqueCode = selectedProductDetail.Uniquecode;
        const offerPrice = offerPrices[product.ID];
        const itemPrice = offerPrice !== undefined ? offerPrice : product.MRP;

        const cartData = [{
            itemId: product.ID,
            uniqueCode: uniqueCode,
            itemName: product.ItemName,
            itemPrice: itemPrice,
            quantity: 1,
            ledname: LedName,
            ledcode: loginId,
            ledemail: LedEmail,
        }];

        try {
            const response = await fetch(`${apiBaseUrl}/cart/add/BLACKBATON_2526`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(cartData),
            });

            if (!response.ok) {
                throw new Error('Failed to add item to cart');
            }

            const result = await response.json();

            if (result.success) {
                alert('Item added to cart successfully!');
            } else {
                alert('Failed to add item to cart. Please try again.');
            }
        } catch (error) {
            console.error('Error adding item to cart:', error);
            alert('An error occurred while adding the item to the cart. Please try again.');
        }
    };

    const [respectedSizeArray, setRespectedSizeArray] = useState([]);

    // Get all images (main + extra) for current color
    // Get all images (main + extra) for current color - EXCLUDING the current main image
    const getAllImagesForCurrentColor = () => {
        if (!currentColorCode || !mainImage) return [];
        const allImages = extraImages[currentColorCode] || [];

        // Filter out the current main image by comparing URLs without query parameters
        return allImages.filter(img => {
            const imgBaseUrl = img.url.split('?')[0];
            const mainBaseUrl = mainImage.split('?')[0];
            return imgBaseUrl !== mainBaseUrl;
        });
    };

    // Get visible images for pagination
    const getVisibleImages = () => {
        const allImages = getAllImagesForCurrentColor();

        const startIdx = startIndex;
        const endIdx = startIdx + imagesPerPage;

        return {
            images: allImages.slice(startIdx, endIdx),
            hasPrev: startIdx > 0,
            hasNext: endIdx < allImages.length,
            total: allImages.length
        };
    };

    // Handler for image pagination
    const handleNext = () => {
        const allImages = getAllImagesForCurrentColor();
        if (startIndex + imagesPerPage < allImages.length) {
            setStartIndex(startIndex + 1);
        }
    };

    const handlePrev = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };

    // Helper function to check if product is visible
    const isProductVisible = (productId) => {
        return visibleProducts.includes(productId);
    };

    // State to track image URLs for similar products
    const [similarProductImages, setSimilarProductImages] = useState({});

    // Update the getSimilarProductImage function to return a promise
    const getSimilarProductImage = async (productItem) => {
        // Check cache first
        if (similarProductImages[productItem.ID]) {
            return similarProductImages[productItem.ID];
        }

        try {
            const imageUrl = await getProductImageUrl(productItem);
            setSimilarProductImages(prev => ({
                ...prev,
                [productItem.ID]: imageUrl
            }));
            return imageUrl;
        } catch (error) {
            console.error('Error getting product image:', error);
            return product1; // Return fallback immediately
        }
    };

    const [modalImage, setModalImage] = useState(false);

    useEffect(() => {
        if (modalImage) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [modalImage]);

    const handleRespectedItemInSize = async (item) => {
        const color = item.color.toString().toUpperCase();
        const md_color = modifiedColors[color]?.name;

        const respectedSizedItems = productItems.filter(item => {
            const itemColor = item.Color?.toUpperCase();
            const itemMdColor = modifiedColors[itemColor]?.name || itemColor;
            return itemMdColor === md_color;
        });

        const sizesArray = respectedSizedItems.map((item) => item.Size);
        setRespectedSizeArray(sizesArray);
    };

    // Handle color selection - also reset pagination
    const handleColorSelection = async (color) => {
        const normalizedColor = color?.toString().toUpperCase();

        if (!Array.isArray(productItems) || productItems.length === 0) {
            console.warn("⚠️ productItems not loaded or empty.");
            return;
        }

        let matchingUniquecode = null;

        if (product.NoSize === 1) {
            matchingUniquecode = productItems.find(
                (item) => item.Color?.toUpperCase() === normalizedColor
            );
        } else {
            setRespectedSizeArray([]);
            matchingUniquecode = productItems.find(
                (item) =>
                    item.Color?.toUpperCase() === normalizedColor &&
                    item.Size === selectedSize
            );
        }

        if (!matchingUniquecode) {
            console.warn("⚠️ No matching product found for", normalizedColor);
            return;
        }

        const colorName = modifiedColors[matchingUniquecode.Color?.toUpperCase()]?.name || normalizedColor;
        const code = `${matchingUniquecode.ItemId}_${colorName}`;

        setSelectedColor(normalizedColor);
        // setCurrentColorCode(code);
        setStartIndex(0); // Reset pagination when color changes

        const mainImgUrl = `${apiLocalUrl}/uploads/${code}.webp`;
        setMainImage(mainImgUrl);

        // Fetch all images (main + extra) for this color
        fetchExtraImages(code);
    };

    // Render loading state
    if (loadingImages === 'loading') {
        return (
            <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
                {isMobile ? <NavbarMob /> : <Navbar />}
                <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[60px] pb-12'>
                    <div className='flex flex-row gap-2 items-center'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>
                </div>
                <div className='w-full flex lg:flex-row flex-col justify-center items-center font-semibold text-md md:text-xl p-5 md:p-10'>
                    <span className="inline-block w-5 h-5 border-2 border-gray-300 border-t-black rounded-full animate-spin"></span>
                </div>
                {isTab ? <FooterMob /> : <Footer />}
            </div>
        );
    }

    if (loadingImages === 'fail') {
        return (
            <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
                {isMobile ? <NavbarMob /> : <Navbar />}
                <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[60px] pb-12'>
                    <div className='flex flex-row gap-2 items-center'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>
                </div>
                <div className='w-full flex lg:flex-row flex-col justify-center items-center font-semibold text-md md:text-xl p-5 md:p-10'>
                    <span>Product is not available!</span>
                </div>
                {isTab ? <FooterMob /> : <Footer />}
            </div>
        );
    }

    if (loadingImages === 'error') {
        return (
            <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
                {isMobile ? <NavbarMob /> : <Navbar />}
                <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[60px] pb-12'>
                    <div className='flex flex-row gap-2 items-center'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>
                </div>
                <div className='w-full flex lg:flex-row flex-col justify-center items-center font-semibold text-md md:text-xl p-5 md:p-10'>
                    <span className='text-red-500'>Error occurred</span>
                </div>
                {isTab ? <FooterMob /> : <Footer />}
            </div>
        );
    }

    // Get visible images (main + extra) for current color
    const { images: visibleImages, hasPrev, hasNext, total: totalImages } = getVisibleImages();
    const isLoadingCurrentExtra = loadingExtraImages[currentColorCode];

    return (
        <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
            {isMobile ? <NavbarMob /> : <Navbar />}

            <div className={`w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[60px] ${isMobile ? 'pb-24' : 'pb-12'}`}>
                <div className='flex flex-row gap-2 items-center'>
                    <div className='w-full flex flex-row gap-2'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>
                    <div className="w-max h-max flex flex-row justify-center items-center border rounded-md">
                        <div className="px-2">
                            <LiveViews pageId={itemName} />
                        </div>
                        {admin === '1' && (
                            <div className="w-7 border-l">
                                <Lottie animationData={animationData} loop={true} />
                            </div>
                        )}
                    </div>
                </div>

                <div className='w-full flex lg:flex-row flex-col lg:h-[589px] h-auto lg:gap-0 gap-5'>
                    <div className='flex lg:flex-row gap-4 lg:w-[50%] w-full h-full'>
                        <div className='lg:w-[25%] h-full lg:flex hidden flex-col justify-center items-center gap-6'>
                            {/* Show all other images for the selected color (excluding current main image) */}
                            {isLoadingCurrentExtra ? (
                                <div className="w-full flex justify-center items-center h-[100px]">
                                    <div className="w-6 h-6 border-2 border-gray-300 border-t-black rounded-full animate-spin"></div>
                                </div>
                            ) : visibleImages.length > 0 ? (
                                <div className='max-h-full h-max flex flex-col justify-center items-start overflow-auto  gap-3'>
                                    {visibleImages.map((img, index) => (
                                        <div key={index} className={`w-[70%] max-h-max border rounded-[10px] bg-[#EEEEEE] flex justify-center items-center cursor-pointer`}
                                            onClick={() => handleThumbnailClick(img.url)}
                                        >
                                            <img
                                                src={img.url}
                                                alt={`${img.isMain ? 'Main' : 'Extra'} image ${index + 1}`}
                                                className="w-full h-max rounded-[10px] object-cover"
                                                loading="lazy"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = product1;
                                                }}
                                            />
                                        </div>
                                    ))}

                                    {/* Navigation - Only show if there are more images */}
                                    {(hasPrev || hasNext) && (
                                        <div className='flex flex-col gap-2 w-[70%] justify-center items-center'>
                                            {hasPrev && (
                                                <div
                                                    className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer bg-black`}
                                                    onClick={handlePrev}
                                                >
                                                    <img src={top} alt="top" />
                                                </div>
                                            )}
                                            {hasNext && (
                                                <div
                                                    className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer bg-black`}
                                                    onClick={handleNext}
                                                >
                                                    <img src={down} alt="down" />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="text-gray-400 text-sm text-center">
                                    No other images available
                                </div>
                            )}
                        </div>

                        {/* Main image display */}
                        <div className='w-[75%] h-auto lg:h-full flex justify-center items-center rounded-lg' onClick={() => setModalImage(true)}>
                            <img
                                src={mainImage}
                                alt="mainimage"
                                loading="lazy"
                                className='w-max max-w-full h-full md:h-max md:max-h-full rounded-lg'
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = product1;
                                }}
                            />
                        </div>

                        {/* Mobile view */}
                        <div className='w-[25%] h-full flex lg:hidden flex-col justify-center items-center gap-3 overflow-hidden'>
                            <div className='w-full h-full flex flex-col justify-center items-center gap-3 overflow-auto'>
                                {visibleImages.map((img, index) => (
                                    <div key={index} className="w-full h-max rounded-[10px] bg-[#EEEEEE] flex justify-center items-center cursor-pointer"
                                        onClick={() => handleThumbnailClick(img.url)}
                                    >
                                        <img
                                            src={img.url}
                                            alt={`${img.isMain ? 'Main' : 'Extra'} image ${index + 1}`}
                                            className="w-full h-full object-contain"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = product1;
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>

                            {/* Mobile navigation */}
                            {(hasPrev || hasNext) && (
                                <div className='h-max w-full flex flex-row justify-center items-center gap-2 mt-2'>
                                    {hasPrev && (
                                        <div
                                            className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer bg-black`}
                                            onClick={handlePrev}
                                        >
                                            <img src={top} alt="top" />
                                        </div>
                                    )}
                                    {hasNext && (
                                        <div
                                            className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer bg-black`}
                                            onClick={handleNext}
                                        >
                                            <img src={down} alt="down" />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Product details section */}
                    <div className='flex flex-col lg:gap-8 gap-5 lg:w-[50%] w-full h-full lg:px-[4%] px-0'>
                        <span className='lg:text-4xl text-xl font-[600] font-montserrat text-left'>{product.ItemName} <br />
                            {modifiedColors[selectedColor]?.name && (
                                <span className='lg:text-[1.5rem] text-[1rem]'>[{modifiedColors[selectedColor]?.name}]</span>
                            )}
                        </span>

                        <div className='lg:hidden flex flex-row gap-3 items-center'>
                            <span className='font-[400] font-montserrat text-sm'>
                                {offerPrices[product.ID] ? 'Offer Price' : 'MRP'}
                            </span>
                            <span className='font-[600] font-montserrat text-base'>
                                ₹ {offerPrices[product.ID] || product.MRP}
                            </span>
                            {offerPrices[product.ID] && (
                                <span className='line-through text-gray-500 text-sm ml-1'>
                                    ₹{product.MRP}
                                </span>
                            )}
                        </div>

                        {/* Size Section */}
                        {product.NoSize !== 1 && uniqueSizes.filter(size => sizeHasColors(size)).length > 0 && (
                            <div className='flex flex-col gap-3'>
                                <span className='lg:text-lg text-sm font-[500] text-[#3F4646] text-left'>Select Size</span>
                                <div className='flex flex-row gap-5'>
                                    {uniqueSizes
                                        .filter(size => size && size.trim() !== '')
                                        .sort((a, b) => sizesAllocated.indexOf(a) - sizesAllocated.indexOf(b))
                                        .map((size) => {
                                            const hasColors = sizeHasColors(size);
                                            const isDisabled = !hasColors;

                                            return (
                                                <div className='flex flex-col gap-1' key={size}>
                                                    <div
                                                        onClick={() => {
                                                            if (!isDisabled && product.NoSize !== 1) {
                                                                setRespectedSizeArray([]);
                                                                handleSizeSelection(size);
                                                            }
                                                        }}
                                                        className={`w-[38px] h-[38px] rounded-[12px] border-2 flex justify-center items-center text-sm font-[500] font-montserrat cursor-pointer 
                                                            ${isDisabled
                                                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed border-[#BEBCBD]'
                                                                : (!respectedSizeArray.includes(size) && respectedSizeArray.length > 0)
                                                                    ? 'bg-[#3C4242] bg-opacity-20 text-[#3C4242]'
                                                                    : respectedSizeArray.length > 0
                                                                        ? 'bg-[#fff] text-[#3C4242]'
                                                                        : 'text-[#3C4242]'
                                                            }
                                                            ${selectedSize === size && !isDisabled ? "border-4 border-[#3C4242]" : "border-[#BEBCBD]"}`}
                                                        title={isDisabled ? "No colors available for this size" : `Select ${size}`}
                                                    >
                                                        {size}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )}

                        {/* Colors Section */}
                        {getUniqueColors(availableColors).length > 0 && (
                            <div className='flex flex-col gap-3'>
                                <span className='lg:text-lg text-sm font-[600] text-[black] text-left'>Colours Available</span>
                                <div className='flex flex-row gap-3 flex-wrap'>
                                    {getUniqueColors(availableColors).map((color) => {
                                        const normalizedColor = color?.toString().toUpperCase();
                                        const colorValue = modifiedColors[normalizedColor]?.hex;

                                        return (
                                            <div
                                                key={normalizedColor}
                                                onClick={() => handleColorSelection(color)}
                                                className={`
                                                    w-[25px] h-[25px] rounded-full cursor-pointer border border-gray-200
                                                    ${selectedColor === normalizedColor
                                                        ? "ring-2 ring-black ring-offset-1"
                                                        : "hover:border-gray-400"}
                                                `}
                                                style={{
                                                    backgroundColor: colorValue || "#ccc",
                                                    borderColor: colorValue === "#FFFFFF" ? "#ccc" : "#ccc",
                                                }}
                                                title={normalizedColor
                                                    .split(" ")
                                                    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
                                                    .join(" ")}
                                                aria-label={`Color ${normalizedColor}`}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        <div className={`flex flex-row gap-4 ${isMobile ? 'fixed bottom-0 left-0 w-full bg-white p-4 z-[100] border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.1)]' : ''}`}>
                            <div className={`${isMobile ? 'flex-[1.5]' : 'lg:w-[35%] w-full'} h-[46px] bg-[black] rounded-[8px] flex flex-row gap-2 items-center justify-center cursor-pointer`} onClick={(e) => handleAddToCart(e)}>
                                <img src={cart1} alt="cart" />
                                <span className='lg:text-lg text-base font-[600] font-montserrat text-[white]'>Add to cart</span>
                            </div>
                            <div className={`h-[46px] border-2 border-[black] rounded-[8px] flex items-center justify-center ${isMobile ? 'flex-1 px-4' : 'w-[25%] lg:flex hidden'}`}>
                                <span className='lg:text-lg text-base font-[600] font-montserrat'> ₹ {offerPrices[product.ID] || product.MRP}</span>
                            </div>
                        </div>

                        <ul className='border-2 border-[#BEBCBD] mt-3 lg:flex hidden' />

                        <div className='grid grid-cols-2 lg:gap-6 gap-3'>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={payment} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Secure payment</span>
                            </div>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={fit} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Size & Fit</span>
                            </div>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={shipping} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Free shipping</span>
                            </div>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={returns} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Free Shipping & Returns</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Fabric Details Section */}
                {fabricData && (
                    <div className="w-full flex lg:flex-row-reverse flex-col gap-10 border-y border-gray-300 mt-5 -mb-10">
                        {/* Left: Fabric Image */}
                        <div className="lg:w-1/2 w-full flex justify-center items-center relative p-10">
                            <div className="w-full aspect-square flex items-center justify-center relative"
                                onMouseEnter={() => setShowZoom(true)}
                                onMouseLeave={() => setShowZoom(false)}
                                onMouseMove={handleMouseMove}
                            >
                                <div className={`w-full h-full bg-black transition-all rounded-lg duration-700`}
                                    style={{
                                        // maskImage: 'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%), linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%)',
                                        // WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%), linear-gradient(to right, transparent 0%, black 20%, black 80%, transparent 100%)',
                                        maskComposite: 'intersect',
                                        WebkitMaskComposite: 'destination-in'
                                    }}
                                >
                                    {fabricData.hasImage ? (
                                        <img
                                            src={`${apiLocalUrl}/uploads/fabric/${currentColorCode}.webp`}
                                            className={`w-full h-full object-cover rounded-lg transition-opacity duration-700`}
                                            alt="Fabric texture"
                                        />
                                    ) : (
                                        <div className="flex flex-col items-center gap-3 text-gray-300">
                                            <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth={1} viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            <span className="text-xs font-bold uppercase tracking-widest">Fabric Preview</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {showZoom && (
                                <div
                                    className="absolute pointer-events-none w-64 h-64 rounded-full border border-white border-opacity-30 shadow-2xl z-50 overflow-hidden"
                                    style={{
                                        left: `${zoomPos.mouseX}px`,
                                        top: `${zoomPos.mouseY}px`,
                                        transform: "translate(-50%,-50%)",
                                        backgroundImage: `url(${apiLocalUrl}/uploads/fabric/${currentColorCode}.webp)`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "500%",
                                        backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`
                                    }}
                                />
                            )}
                        </div>

                        {/* Right: Fabric Information */}
                        <div className="lg:w-1/2 w-full flex flex-col justify-center gap-8">
                            <div>
                                <h2 className="text-3xl font-900 text-black mb-4 text-left font-montserrat">
                                    Fabric that Moves You
                                </h2>
                                <p className="text-gray-500 text-left font-medium leading-relaxed max-w-xl font-montserrat">
                                    Refined Through Years of Passionate Research & Careful Crafting, Designed to Deliver the Comfort and Style You Deserve.
                                </p>
                            </div>

                            <div className="space-y-6">
                                {/* GSM */}
                                <div className="flex items-center justify-between border-b border-gray-100 pb-3 max-w-md">
                                    <span className="text-sm font-bold text-gray-500 uppercase tracking-widest font-montserrat">GSM</span>
                                    <span className="text-xl font-600 text-black font-montserrat">{fabricData.gsm || 'N/A'}</span>
                                </div>

                                {/* Metrics with Dot Rating */}
                                {[
                                    { label: 'Drying Speed', value: fabricData.dryingSpeed, icon: drops },
                                    { label: 'Cooling', value: fabricData.cooling, icon: winter },
                                    { label: 'Breathability', value: fabricData.breathability, icon: wind_sign },
                                    { label: 'Stretchability', value: fabricData.stretchability, icon: strechable }
                                ].map((stat, idx) => (
                                    <div key={idx} className="flex items-center justify-between max-w-md">
                                        <div className="flex items-center gap-2">
                                            <img src={stat.icon} alt={stat.label} className="w-4 h-4 object-contain" />
                                            <span className="text-sm font-bold text-gray-500 uppercase tracking-widest font-montserrat">
                                                {stat.label}
                                            </span>
                                        </div>

                                        <div className="relative flex items-center gap-4">

                                            {/* line behind circles */}
                                            <div className="absolute left-0 right-0 h-[1px] bg-gray-300 top-1/2 -translate-y-1/2"></div>

                                            {[1, 2, 3, 4, 5].map((dot) => (
                                                <div
                                                    key={dot}
                                                    className={`relative z-10 w-3.5 h-3.5 rounded-full border transition-all duration-500 ${dot <= stat.value
                                                        ? 'bg-[#595959] border-[#595959] scale-110 shadow-sm'
                                                        : 'bg-gray-200 border-gray-300'
                                                        }`}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {similarProducts.length > 0 && (
                    <div className='flex flex-col gap-6 lg:pb-12 pb-6'>
                        <div className='flex flex-row w-full mt-10'>
                            <div className='flex flex-row gap-4 items-center'>
                                <img src={line} alt="line" />
                                <span className='lg:text-xl text-base font-[600] font-montserrat'>Similar Products</span>
                            </div>
                        </div>

                        {loadingProducts ? (
                            <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 w-full gap-5">
                                {Array.from({ length: 4 }).map((_, index) => {
                                    const opacity = 1 - index * 0.25; // 1 → 0.75 → 0.5

                                    return (
                                        <div
                                            key={`skeleton-${index}`}
                                            className="flex flex-col gap-4 animate-pulse"
                                            style={{ opacity }}
                                        >
                                            <div className="aspect-[3/4] bg-gray-100 rounded-2xl" />
                                            <div className="h-4 w-3/4 bg-gray-100 rounded-full" />
                                            <div className="h-4 w-1/4 bg-gray-100 rounded-full" />
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className='grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 w-full gap-x-5 gap-y-10'>
                                {similarProducts.map((similarProduct, index) => {
                                    const isVisible = isProductVisible(similarProduct.ID);
                                    const productImageUrl = similarProductImages[similarProduct.ID];

                                    return (
                                        <SimilarProductItem
                                            key={similarProduct.ID}
                                            product={similarProduct}
                                            isVisible={isVisible}
                                            productImageUrl={productImageUrl}
                                            wishlistItems={wishlistItems}
                                            removeFromWishlist={removeFromWishlist}
                                            addToWishlist={addToWishlist}
                                            fullimage={fullimage}
                                            index={index}
                                            getSimilarProductImage={getSimilarProductImage}
                                            similarProductImages={similarProductImages}
                                        />
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {isTab ? <FooterMob /> : <Footer />}

            {modalImage && (
                <div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-black bg-opacity-50 z-50">
                    <Modal imageUrl={mainImage} onClose={() => setModalImage(false)} />
                </div>
            )}
        </div>
    );
}

export default FullImage;